import React, {useState} from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, Radio, RequiredValidator, SwitchGroup, TextField, ULID } from '../../Components/Form';

const AddEditBroadcast = ({broadcast, isOpen, setIsOpen, save, then}) => {
    return <Modal title={broadcast ? 'Update Broadcast' : 'Add Broadcast'} isOpen={!!isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner {...{broadcast, save, then}} />}
    </Modal>
}

const Inner = ({broadcast, save, then}) => {
    const [isTransactional, setIsTransactional] = useState(broadcast?.purpose === 'Transactional' ?? false);

    let data = {channels: {Email: true}};
    if (broadcast) {
        data = {
            id: broadcast.id,
            title: broadcast.title,
            templateId: broadcast.templateId,
            purpose: broadcast.purpose,
            channels: broadcast.channels.reduce((a, c) => ({...a, [c]: true}), {})
        };
    }

    return <Form data={data} onSubmit={save} afterSubmit={then} closeModalOnSubmit>
        <ULID name="broadcastId" />
        <TextField name="title" label="Title" validators={[RequiredValidator]} />
        <Radio layout="smallCards"
            name="purpose"
            label="Purpose"
            options={[
                {
                    value: 'Promotional',
                    label: 'Promotional',
                    help: 'For example offers, updates, and special deals. These are not sent to customers who have opted out.',
                },
                {
                    value: 'Transactional',
                    label: 'Transactional',
                    help: 'Transactional messages must be related to services the customers are receiving and will be sent to all selected customers.',
                },
            ]}
            validators={[RequiredValidator]}
            onChange={(v) => {
                setIsTransactional(v === 'Transactional');
            }}
        />
        <SwitchGroup label="Send using"
            name="channels"
            validators={[RequiredValidator]}
            switches={[
                {
                    name: 'Email',
                    label: 'Email',
                    // help: 'There is no cost to send by email'
                },
                {
                    name: 'SMS',
                    label: 'SMS',
                    help: isTransactional ?
                        'Sending by SMS will use your SMS credits.' :
                        'SMS is not supported for promotional broadcasts at this time.',
                    disabled: !isTransactional,
                },
            ]}
        />
        <Actions submit={{label: broadcast ? 'Update' : 'Add'}} cancel />
    </Form>
}

export default AddEditBroadcast;